import { TerminEventSearchPageProps, TerminEventSearchParams } from "@/pages/termin-event-search-page/types";
import { Select, Label, Field, Textfield, Button } from "@digdir/designsystemet-react";
import { useUpdateTerminEventSearchData } from "@/pages/termin-event-search-page/use-update-termin-event-search-data";
import { useState, useRef, useEffect } from "react";
import { NifEvent } from "@/components/blocks/termin-search-block/types";

export function TerminEventFilterSection({ setEvents, initial }: { setEvents: (events: NifEvent[]) => void; initial: TerminEventSearchPageProps }) {
    const filterRef = useRef<HTMLFormElement>(null);
    const [filterData, setFilterData] = useState(initial.filterSection.searchParams);
    const { updateSearchParams, resetFilter } = useUpdateTerminEventSearchData({ setEvents, filterData, setFilterData });
    const [query, setQuery] = useState<string>(initial.filterSection.searchParams.queryText ?? "");

    useEffect(() => {
        setFilterData(initial.filterSection.searchParams);
        setQuery(initial.filterSection.searchParams.queryText ?? "");
    }, [initial.filterSection.searchParams.queryText]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const fd = new FormData(e.currentTarget);
        const q = String(fd.get("QueryText") ?? "").trim();
        setQuery(q);

        updateSearchParams({ queryText: q || undefined, selectedPageNumber: 0 });
    };

    const handleReset = () => {
        filterRef.current?.reset();
        resetFilter();
        setQuery("");
    };

    function setDateFrom(nextFrom: string) {
        const patch: Partial<TerminEventSearchParams> = { fromDate: nextFrom || undefined };
        if (filterData.toDate && nextFrom && nextFrom > filterData.toDate) patch.toDate = nextFrom;
        updateSearchParams(patch);
    }

    function setDateTo(nextTo: string) {
        const patch: Partial<TerminEventSearchParams> = { toDate: nextTo || undefined };
        if (filterData.fromDate && nextTo && nextTo < filterData.fromDate) patch.fromDate = nextTo;
        updateSearchParams(patch);
    }

    return (
        <form onSubmit={handleSubmit} ref={filterRef} className="flex flex-col gap-4 bg-tinted p-4 ">
            <div className="flex flex-col md:flex-row gap-2 items-center">
                <Textfield
                    name="QueryText"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    aria-label="søk"
                    placeholder="søk"
                    className="block rounded-md border border-detail-gray w-full"
                />
                <div className="hidden md:flex md:flex-row gap-2 items-center">
                    <Button type="submit" variant="primary" className="rounded-md w-full">
                        Søk
                    </Button>
                    <Button type="button" variant="tertiary" className="rounded-md w-full px-6" onClick={handleReset}>
                        Tilbakestill
                    </Button>
                </div>
            </div>

            <div className=" flex flex-col md:flex-row gap-4  mt-4 ">
                <div className="flex gap-4 flex-col md:flex-row">
                    <Field>
                        <Label>Fra dato</Label>
                        <input
                            type="date"
                            name="FromDate"
                            value={filterData.fromDate ?? ""}
                            max={filterData.toDate ?? undefined}
                            onChange={(e) => setDateFrom(e.target.value)}
                            className="block h-12 font-body text-md md:text-sm rounded-md border border-detail-gray px-3 py-2 w-full md:w-auto"
                        />
                    </Field>

                    <Field>
                        <Label>Til dato</Label>
                        <input
                            type="date"
                            name="ToDate"
                            value={filterData.toDate ?? ""}
                            min={filterData.fromDate ?? undefined}
                            onChange={(e) => setDateTo(e.target.value)}
                            className="block h-12 font-body text-md md:text-sm rounded-md border border-detail-gray px-3 py-2 w-full md:w-auto"
                        />
                    </Field>
                </div>

                <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
                    {initial.filterSection.showActivities && (
                        <Field>
                            <Label htmlFor="activity" className="block text-sm font-medium mb-1">
                                Aktivitet:
                            </Label>
                            <Select
                                className="block w-full rounded-md border border-detail-gray px-3 py-2 pr-10"
                                value={filterData?.selectedActivity ?? ""}
                                onChange={(e: React.ChangeEvent<HTMLSelectElement> | any) =>
                                    updateSearchParams({ selectedActivity: (e?.target?.value ?? e) || undefined })
                                }
                            >
                                {initial.filterSection.activities.map((a) => (
                                    <Select.Option key={a.value} value={a.value}>
                                        {a.text}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Field>
                    )}

                    {initial.filterSection.showSportDistricts && (
                        <Field>
                            <Label htmlFor="district" className="block text-sm font-medium mb-1">
                                Distrikt:
                            </Label>
                            <Select
                                className="block rounded-md border border-detail-gray px-3 py-2"
                                value={filterData.selectedDistrict ?? ""}
                                onChange={(e: React.ChangeEvent<HTMLSelectElement> | any) =>
                                    updateSearchParams({ selectedDistrict: (e?.target?.value ?? e) || undefined })
                                }
                            >
                                {initial.filterSection.sportDistricts.map((d) => (
                                    <Select.Option key={d.value} value={d.value}>
                                        {d.text}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Field>
                    )}
                </div>

                <div className="w-full flex md:hidden flex-row gap-2 items-center">
                    <Button type="submit" variant="primary" className="rounded-md w-full ">
                        Søk
                    </Button>
                    <Button type="button" className="rounded-md " onClick={handleReset}>
                        Tilbakestill
                    </Button>
                </div>
            </div>
        </form>
    );
}